export default __webpack_public_path__ + "static/media/reply-camera.87990067.svg";